import {MZSearchDialog} from '../component/azsearch/azsearch' 
const { registerFormatType } = wp.richText;
const { __ } = wp.i18n;
 
const AmzLinkButton = ( props ) => {
    // console.log(props);
     return <MZSearchDialog isFormater={true} formaterProps={props} item_ids={[]} />
};
 
registerFormatType(
    'themesfirst/amazonlinkformat', {
        title: __('Amazon link (i2-azon)', 'themesfirst'),
        tagName: 'a',
        className: 'i2-azon-amazon-link',
        edit: AmzLinkButton,
    }
);